import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import Actions from "../../../../../store/actions/customerActions";
import { handle } from "./../../../../../common/responseHandler";
import Loader from "../../../../Common/Loader";
import Vehicle from "./Vehicles/Vehicle";
import NotFound from "../../../../Common/NotFound";
import Subscriptions from "./Subscriptions";
import Divider from "../../../../Common/Divider";

function Vehicles({ customer }) {
	const dispatch = useDispatch();
	const isLoading = useSelector(state => state.loader);

	const [selectedVehicleVin, setSelectedVehicleVin] = useState(``);

	useEffect(() => {
		if (customer.uuid && !customer.hasVehiclesLoaded) {
			dispatch(Actions.getVehicles(customer.uuid)).catch(handle);
		}
	}, [customer.hasVehiclesLoaded, customer.uuid, dispatch]);

	function getSelectedVehicle() {
		return (
			customer.vehicles &&
			customer.vehicles.find(vehicle => {
				return vehicle.vin === selectedVehicleVin;
			})
		);
	}

	return isLoading && !_.get(customer, `hasVehiclesLoaded`) ? (
		<Loader />
	) : (
			<>
				<div className="row equal-height">
					{_.some(customer.vehicles) && Array.isArray(customer.vehicles) ? (
						customer.vehicles.map(vehicle => {
							return (
								<div className="col-xs-6" key={vehicle.vin}>
									<Vehicle
										vehicle={vehicle}
										showSubscriptionForVehicle={() => {
											setSelectedVehicleVin(vehicle.vin);
										}}
									/>
								</div>
							);
						})
					) : (
							<NotFound>No vehicles found for this customer...</NotFound>
						)}
				</div>

				<Divider />
				<Subscriptions uuid={customer.uuid} vehicle={getSelectedVehicle()} />
			</>
		);
}

Vehicles.propTypes = {
	customer: PropTypes.object.isRequired
};
export default Vehicles;
